import { Link } from 'react-router-dom';
import './Footer.css';

// Enlaces internos → Link; sociales aún sin URL real (placeholder '#').
const ORDENES = [
  { label: 'Contacta con nosotros', to: '/contacto' },
  { label: 'Preguntas frecuentes', to: '/en-construccion' },
  { label: 'Entregas y devoluciones', to: '/policies?section=envios' },
  { label: 'Historial de pedidos', to: '/account' },
  { label: 'Rastrea tu pedido', to: '/account' },
  { label: 'Reembolsos y devoluciones', to: '/policies?section=envios' },
];

const DISTRIBUCION = [
  { label: 'Acceso distribuidores', to: '/socio' },
  // Abre el mapa de afiliados del menú (megamenú en desktop, pantalla completa en mobile)
  { label: 'Localiza un distribuidor', event: 'phys:open-store-locator' },
  { label: 'Ser distribuidor Physiology', to: '/socios-y-distribuidores' },
];

const MI_CUENTA = [
  { label: 'Libreta de direcciones', to: '/account' },
  { label: 'Detalles de la cuenta', to: '/account' },
  { label: 'Empleo', to: '/en-construccion' },
];

const ACERCA = [
  { label: 'Nuestra historia', to: '/nuestra-historia' },
  { label: 'Fundación', to: '/filosofia' },
  { label: 'Empleo', to: '/en-construccion' },
  { label: 'Política de privacidad', to: '/policies?section=privacidad' },
  { label: 'Política de cookies', to: '/policies?section=cookies' },
];

const SOCIAL = [
  { label: 'Instagram', href: 'https://www.instagram.com/physiology_mx' },
  { label: 'Facebook', href: 'https://www.facebook.com/physiologyskincareMX/' },
  { label: 'LinkedIn', href: 'https://es.linkedin.com/company/physiology-skincare' },
];

const Footer = () => {
  return (
    <footer className="ftr">
      <div className="ftr-inner">
        <div className="ftr-grid">

          {/* Newsletter + Sostenibilidad */}
          <div className="ftr-news">
            <h3 className="ftr-news-title">Suscríbete para recibir comunicaciones de Physiology</h3>

            {/* Newsletter: se conecta después. Por ahora no envía. */}
            <form className="ftr-news-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                className="ftr-news-input"
                placeholder="Correo electrónico"
                aria-label="Correo electrónico"
              />
              <button type="submit" className="ftr-news-btn" aria-label="Suscribirse">→</button>
            </form>

            <label className="ftr-consent">
              <input type="checkbox" />
              <span>
                Suscríbete para recibir comunicaciones. Al suscribirte, confirmas que has leído y aceptas nuestra{' '}
                <Link to="/policies?section=privacidad">política de privacidad</Link>.
              </span>
            </label>

            <div className="ftr-sustain">
              <h3 className="ftr-h">Sostenibilidad</h3>
              <p>
                Nuestros productos son veganos y libres de pruebas en animales. Estamos comprometidos con la
                transparencia y la cadena ética. <Link to="/sostenibilidad">Saber más</Link>
              </p>
            </div>
          </div>

          {/* Órdenes y soporte */}
          <nav className="ftr-col" aria-label="Órdenes y soporte">
            <h3 className="ftr-h">Órdenes y soporte</h3>
            <ul className="ftr-list">
              {ORDENES.map((it) => (
                <li key={it.label}><Link className="ftr-link" to={it.to}>{it.label}</Link></li>
              ))}
            </ul>
          </nav>

          {/* Distribución + Mi cuenta */}
          <nav className="ftr-col" aria-label="Distribución">
            <h3 className="ftr-h">Distribución</h3>
            <ul className="ftr-list">
              {DISTRIBUCION.map((it) => (
                <li key={it.label}>
                  {it.event ? (
                    <button
                      type="button"
                      className="ftr-link ftr-link--btn"
                      onClick={() => window.dispatchEvent(new Event(it.event))}
                    >
                      {it.label}
                    </button>
                  ) : (
                    <Link className="ftr-link" to={it.to}>{it.label}</Link>
                  )}
                </li>
              ))}
            </ul>
            <div className="ftr-subgroup">
              <h3 className="ftr-h">Mi cuenta</h3>
              <ul className="ftr-list">
                {MI_CUENTA.map((it) => (
                  <li key={it.label}><Link className="ftr-link" to={it.to}>{it.label}</Link></li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Acerca de */}
          <nav className="ftr-col" aria-label="Acerca de">
            <h3 className="ftr-h">Acerca de</h3>
            <ul className="ftr-list">
              {ACERCA.map((it) => (
                <li key={it.label}><Link className="ftr-link" to={it.to}>{it.label}</Link></li>
              ))}
            </ul>
          </nav>

          {/* Redes sociales */}
          <nav className="ftr-col ftr-social" aria-label="Redes sociales">
            <h3 className="ftr-h">Redes sociales</h3>
            <ul className="ftr-list">
              {SOCIAL.map((it) => (
                <li key={it.label}>
                  <a className="ftr-link" href={it.href} target="_blank" rel="noopener noreferrer">{it.label}</a>
                </li>
              ))}
            </ul>
          </nav>

        </div>

        <div className="ftr-copy">© {new Date().getFullYear()} Physiology Skincare Co.</div>
      </div>
    </footer>
  );
};

export default Footer;
